import { Link, LinkSize, LinkVariant } from '@ui/common/components/Link';
import { useSearchParams } from 'react-router';
import { useConfirmNewsletterMutation } from '@data/newsletters/useConfirmNewsletterMutation';
import { useEffect } from 'react';

export const NewsletterConfirm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { mutate, isPending, data, error } = useConfirmNewsletterMutation();

  useEffect(() => {
    if (token && !isPending && typeof data === 'undefined') {
      mutate(token);
    }
  }, [data, error, isPending, mutate, token]);

  if (!data || error) {
    return (
      <div>
        <h1>You token has expired. Please re-subscribe for the newsletter and click on the link in your mail box</h1>
      </div>
    );
  }

  return (
    <div className="newsletter-confirm">
      <h1>
        You have successfully subscribed to the <br />
        {import.meta.env.VITE_SITE_NAME}’s weekly newsletter.
      </h1>
      <Link
        url={`/news`}
        label={'Latest News'}
        openInNewTab={false}
        variant={LinkVariant.Contained}
        size={LinkSize.lg}
      />
    </div>
  );
};
